/**
 * The code-split modules a page load waits on after the App chunk: the Design v2 shell and the
 * Home screen. Each loader is the one `import()` of its module, shared by the lazy component that
 * renders it (`App.tsx`, `screens/Overview/register.ts`) and by `index.tsx`, which starts them
 * beside the App chunk instead of after App has loaded, evaluated and rendered (a round trip
 * each on a cold cache, the first load after every release). One `import()` per module, so the
 * early start and the lazy component always name the same chunk.
 */
export const loadWorkspaceShell = () => import("./shell/BrowserWorkspaceShell");
export const loadOverviewScreen = () => import("./screens/Overview/Overview");
